module.exports = "pegasus_template/assets/cloud-card.png";